import { jsonArrayMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class CollectionOperationRequest {
  @jsonArrayMember(String)
  public readonly includedIds?: Nillable<Guid[]>;

  @jsonArrayMember(String)
  public readonly excludedIds?: Nillable<Guid[]>;

  @jsonArrayMember(String)
  public readonly isAllSelected?: Nillable<boolean>;

  public constructor(
    private readonly data: {
      includedIds?: Nillable<Guid[]>;
      excludedIds?: Nillable<Guid[]>;
      isAllSelected?: Nillable<boolean>;
    },
  ) {
    this.includedIds = this.data.includedIds;
    this.excludedIds = this.data.excludedIds;
    this.isAllSelected = this.data.isAllSelected;
  }
}
